export const baseURL =
  'https://6uprea9ha9.execute-api.eu-west-2.amazonaws.com/sendContactEmail';

export const handleBookingURL =
  'https://6uprea9ha9.execute-api.eu-west-2.amazonaws.com/handleBooking';
